import { render } from "./Works.vue?vue&type=template&id=1926a43c&scoped=true&bindings={\"isThumbnail\":\"props\",\"router_link\":\"data\",\"message\":\"data\",\"pageUrl\":\"data\",\"mediaUrl\":\"data\",\"projects\":\"data\",\"defaultAppImage\":\"data\",\"isLoading\":\"data\",\"getAppImage\":\"options\"}"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"

import "./Works.vue?vue&type=style&index=0&id=1926a43c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1926a43c"

export default script